var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_45_3264",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_45_3264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 22C6 22 5.35417 21.7458 4.8125 21.2375C4.27083 20.7292 4 20.1 4 19.35V5.39999C4 4.76665 4.19583 4.19999 4.5875 3.69999C4.97917 3.19999 5.49167 2.88332 6.125 2.74999L16 0.799988V16.8L6.525 18.7C6.375 18.7333 6.25 18.8125 6.15 18.9375C6.05 19.0625 6 19.2 6 19.35C6 19.5333 6.075 19.6875 6.225 19.8125C6.375 19.9375 6.55 20 6.75 20H18V3.99999H20V22H6.75ZM7 16.575L9 16.175V4.22499L7 4.62499V16.575Z",
    fill: "#056D62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveNotes);
export default __webpack_public_path__ + "static/media/activeNotes.ef4169dbbe378a4d948c1e33131c8980.svg";
export { ForwardRef as ReactComponent };